import { render, staticRenderFns } from "./coin-icon.vue?vue&type=template&id=664b24a6&scoped=true&lang=pug&"
import script from "./coin-icon.vue?vue&type=script&lang=js&"
export * from "./coin-icon.vue?vue&type=script&lang=js&"
import style0 from "./coin-icon.vue?vue&type=style&index=0&id=664b24a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664b24a6",
  null
  
)

export default component.exports